import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import { CleanButton } from 'src/common/components/Button';
import { colors, shadows } from 'src/config/colors';
import { StaticPagePanelItem } from 'src/common/models/staticPage';

const Item = styled(CleanButton)<{ $active: boolean }>`
  align-items: center;
  border-radius: 0.25rem;
  color: ${colors.blue};
  display: flex;
  margin-right: -1.5rem;
  padding: 0.9375rem 1.5rem 0.9375rem 2.125rem;
  text-align: left;
  white-space: normal;
  width: calc(100% + 1.5rem);
  line-height: 1.25rem;

  ${({ $active }) =>
    $active &&
    css`
      background: ${colors.white};
      box-shadow: ${shadows.drop1};
      color: ${colors.red};
      margin-top: -0.125rem;
      padding-bottom: 1rem;
      padding-top: 1rem;
      position: relative;
      top: 0.0625rem;
    `};
`;

const Title = styled.span`
  flex: 1 1 auto;
  font-size: 0.75rem;
  line-height: 1.1875rem;
  padding-right: 0.5rem;

  a:link,
  a:visited {
    color: ${colors.blue};
  }
`;

export interface StaticPanelLeftItemProps {
  active?: boolean;
  panelItem: StaticPagePanelItem;
}

export const StaticPanelLeftItem: FC<StaticPanelLeftItemProps> = ({
  active = false,
  panelItem,
}) => (
  <Item
    $active={active}
    key={panelItem.id}
    onClick={() =>
      document?.getElementById(panelItem.id)?.scrollIntoView({
        behavior: 'smooth',
      })
    }
  >
    <Title>{panelItem.title}</Title>
  </Item>
);
